// MJ2: kartan öppnas på markens position. Första GPS-fixen flyttar bara kartan till
// mig om jag är på eller nära marken (eller om marken saknar position) – annars
// hamnade man hemma i stället för på marken när man gick in från Min jakt.

/** Så långt utanför markgränsen (eller från markens punkt) räknas man som "på marken". */
export const NEAR_MARK_M = 3000;

interface MarkGeo { mapLat?: number | null; mapLng?: number | null; coordinatesJson?: string | null }

/** Alla koordinater [lng, lat] i en GeoJSON (Feature, FeatureCollection, Geometry). */
function collectCoords(g: unknown, out: [number, number][]): void {
  if (!g || typeof g !== 'object') return;
  const o = g as Record<string, unknown>;
  if (Array.isArray(o.features)) { o.features.forEach(f => collectCoords(f, out)); return; }
  if (o.geometry) { collectCoords(o.geometry, out); return; }
  if (Array.isArray(o.geometries)) { o.geometries.forEach(x => collectCoords(x, out)); return; }
  const walk = (c: unknown) => {
    if (!Array.isArray(c)) return;
    if (c.length >= 2 && typeof c[0] === 'number' && typeof c[1] === 'number') { out.push([c[0], c[1]]); return; }
    c.forEach(walk);
  };
  walk(o.coordinates);
}

/** Markgränsens ytterkanter, eller null om gräns saknas. */
export function markBounds(coordinatesJson?: string | null): { s: number; w: number; n: number; e: number } | null {
  if (!coordinatesJson) return null;
  let geo: unknown;
  try { geo = typeof coordinatesJson === 'string' ? JSON.parse(coordinatesJson) : coordinatesJson; } catch { return null; }
  const pts: [number, number][] = [];
  collectCoords(geo, pts);
  const valid = pts.filter(([lng, lat]) => Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180);
  if (!valid.length) return null;
  return {
    s: Math.min(...valid.map(p => p[1])), n: Math.max(...valid.map(p => p[1])),
    w: Math.min(...valid.map(p => p[0])), e: Math.max(...valid.map(p => p[0])),
  };
}

/** Ska första GPS-fixen flytta kartan till mig? */
export function followFirstFix(mark: MarkGeo, pos: { lat: number; lng: number }, nearM = NEAR_MARK_M): boolean {
  const b = markBounds(mark.coordinatesJson);
  const dLat = nearM / 111_320;
  if (b) {
    const dLng = nearM / (111_320 * Math.max(0.1, Math.cos((pos.lat * Math.PI) / 180)));
    return pos.lat >= b.s - dLat && pos.lat <= b.n + dLat && pos.lng >= b.w - dLng && pos.lng <= b.e + dLng;
  }
  if (mark.mapLat != null && mark.mapLng != null && (mark.mapLat !== 0 || mark.mapLng !== 0)) {
    const x = (pos.lng - mark.mapLng) * 111_320 * Math.cos((mark.mapLat * Math.PI) / 180);
    const y = (pos.lat - mark.mapLat) * 111_320;
    return Math.hypot(x, y) <= nearM;
  }
  return true; // marken saknar position – visa mig
}
